import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'billingPeriod'
})
export class BillingPeriodPipe implements PipeTransform {

  transform(value: string) {
    if (value.length>=2) {
      var months = value.substr(0,value.length-value.indexOf('m'))
      if (months == '1')
        return 'mese'
      return months + ' mesi'
    }
    return null;
  }
}
